import { observable, runInAction } from 'mobx';
import { CommonModel } from 'services/Main/common_services';
import { CriterialListModel, ICriterialServices } from 'services/Main/criterial_services';


export type CriterialStore = {
  criterialRespone: {
    data: CommonModel[];
    message: string;
    isSuccess: boolean;
  };

  criterialListRespone: {
    data: CriterialListModel[];
    message: string;
    isSuccess: boolean;
  };

};

export interface ICriterialPresenter {
  createStore(): CriterialStore;

  // danh sách tiêu chí
  getDataCriterial(store: CriterialStore): Promise<void>;

  // danh sách tiêu chí (new)
  getDataCriterial2(store: CriterialStore): Promise<void>;

  //  data từng tiêu chí
  getDataDetailCriterial(store: CriterialStore, key: string): Promise<void>


}

export function createCriterialPresenter({ criterialServices }: { criterialServices: ICriterialServices }): ICriterialPresenter {
  return {
    createStore: (): CriterialStore =>
      observable({
        criterialRespone: {
          data: [],
          message: '',
          isSuccess: false,
        },
        criterialListRespone: {
          data: [],
          message: '',
          isSuccess: false,
        },
        lisCriterial: []
      }),
    // danh sách tiêu chí
    getDataCriterial: async (store: CriterialStore) => {
      try {
        const result = await criterialServices.getDataCriterial();
        runInAction(() => {
          store.criterialRespone = result;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // danh sách tiêu chí (new)
    getDataCriterial2: async (store: CriterialStore) => {
      try {
        const result = await criterialServices.getDataCriterial2();
        runInAction(() => {
          store.criterialListRespone.data = result.data;
          store.criterialListRespone.isSuccess = result.isSuccess;
          store.criterialListRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },


    //  data từng tiêu chí
    getDataDetailCriterial: async (store: CriterialStore, key: string) => {
      try {
        const result = await criterialServices.getDataDetailCriterial(key);
        runInAction(() => {
          store.criterialRespone = result;
        });
      } catch (error) {
        console.log(error);
      }
    },


  };
}
